import React from 'react';
import '../../assets/css/shimmer.css'

const LoaderCilentSec = () => {
    // console.log(customerCm);

    return (
        <section className="cilents-sec">
            <div className="block-title">
                <h6 className="title">مشتریان</h6>
            </div>
            <div className='row'>
                <div className='col-6 col-sm-4 col-xl-2'>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
                <div className='col-6 col-sm-4 col-xl-2'>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
                <div className='col-6 col-sm-4 col-xl-2 d-none d-sm-block '>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
                <div className='col-6 col-sm-4 col-xl-2 d-none d-xl-block'>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
                <div className='col-6 col-sm-4 col-xl-2 d-none d-xl-block'>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
                <div className='col-6 col-sm-4 col-xl-2 d-none d-xl-block'>
                    <div className="cilents-slider-item d-block shimmerBox">
                        <div className="shine shimmerBoxIn"></div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default LoaderCilentSec;